// extracted by mini-css-extract-plugin
export var divider = "_xw-0";